import { TextField, TextFieldProps } from '@mui/material'
import { useSnackbar } from 'notistack'
import { KeyboardEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const ALLOWED_KEYS = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter', 'Escape']

const digitRegexp = /^[0-9]$/

const keyIsAllowed = (key: string, canFloat?: boolean) =>
  digitRegexp.test(key) || ALLOWED_KEYS.includes(key) || (canFloat && key === '.')

export const NumbersOnlyTextField = ({
  canFloat,
  inputProps,
  slotProps,
  ...props
}: TextFieldProps & { canFloat?: boolean }) => {
  const { t } = useTranslation('@cibo/ui/NumbersOnlyTextField')
  const { enqueueSnackbar } = useSnackbar()

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (!keyIsAllowed(event.key, canFloat)) {
        event.preventDefault()

        enqueueSnackbar(
          !canFloat && event.key === '.' ? t('decimalsNotAllowed') : t('useValidNumber'),
          {
            variant: 'warning',
            preventDuplicate: true,
          }
        )
      }

      // @ts-ignore inputProps does exist on input slotProps, but the types don't include it.
      slotProps ? slotProps.input?.inputProps?.onKeyDown?.(event) : inputProps?.onKeyDown?.(event)
      props.onKeyDown?.(event)
    },
    // @ts-ignore inputProps does exist on input slotProps, but the types don't include it.
    [enqueueSnackbar, inputProps, slotProps?.input?.inputProps]
  )

  return (
    <TextField
      {...props}
      onKeyDown={handleKeyDown}
      slotProps={{
        input: {
          inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
            ...inputProps,
            // @ts-ignore inputProps does exist on input slotProps, but the types don't include it.
            ...slotProps?.input?.inputProps,
          },
          ...slotProps?.input,
        },
        ...slotProps,
      }}
      fullWidth
      autoFocus
    />
  )
}
